(function ($) {
    $.fn.workstreamBody = function () {
        return this.each(() => {

            //$('.main-left-content, .page-content-container').wrapAll('<div class="container main-content-wrapper"></div>');

        });
    }

})($);


export default {
    init() {
        // JavaScript to be fired on the workstream details
        $('.workstream-content-body').workstreamBody();

        if ($('.workstream-content-body').length === 0) {
            return;
        }
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-workstream.js